// extracted by mini-css-extract-plugin
export var blurBox = "notification-module--blur-box--0a710";
export var button = "notification-module--button--495f9";
export var container = "notification-module--container--92f0a";
export var contentBox = "notification-module--content-box--75d75";
export var contentText = "notification-module--content-text--0a8eb";
export var date = "notification-module--date--dbfa0";
export var icon = "notification-module--icon--73d0c";
export var read = "notification-module--read--0e88b";
export var titleText = "notification-module--title-text--0ae44";